import { useLocation, useNavigate } from 'react-router-dom';

export function useQueryString() {
  const location = useLocation();
  const navigate = useNavigate();
  const queryStringParams = new URLSearchParams(location.search);

  const updateUrl = () => {
    const newSearch = `?${queryStringParams.toString()}`;
    if (newSearch !== location.search) {
      navigate({ ...location, search: newSearch }, { replace: true });
    }
  };

  const buildQueryStringFromParams = (params) => {
    params.forEach((param) => {
      if (!queryStringParams.has(param.key)) {
        queryStringParams.append(param.key, param.value);
      }
    });
    const newSearch = `?${queryStringParams.toString()}`;
    updateUrl();
    return newSearch;
  };

  const getQueryStringParam = (paramName, paramValue = null) => {
    if (paramValue) {
      const values = queryStringParams.getAll(paramName);
      return values.includes(paramValue) ? [paramValue] : [];
    }
    return queryStringParams.get(paramName);
  };

  const setQueryStringParam = (paramName, paramValue) => {
    queryStringParams.set(paramName, paramValue);
    updateUrl();
  };

  const getQueryString = () => {
    return `?${queryStringParams.toString()}`;
  };

  const deleteQueryStringParam = (paramName, paramValue = null) => {
    if (paramValue) {
      const values = queryStringParams.getAll(paramName).filter((value) => value !== paramValue);
      queryStringParams.delete(paramName);
      values.forEach((value) => queryStringParams.append(paramName, value));
    } else {
      queryStringParams.delete(paramName);
    }
    updateUrl();
  };

  const appendQueryStringParam = (paramName, paramValue) => {
    queryStringParams.append(paramName, paramValue);
    updateUrl();
    return `?${queryStringParams.toString()}`;
  };

  return {
    buildQueryStringFromParams,
    getQueryStringParam,
    getQueryString,
    setQueryStringParam,
    deleteQueryStringParam,
    appendQueryStringParam,
  };
}